<template>
	<div>
		<div class="col-12 text-left item-group">
			<i class="fa fa-arrow-circle-right"/>
			VALORES DESSE CAMPO
		</div>

		<div class="mb-2 text-left">
			<ed-button
				icon="fa fa-plus-circle"
				type="text"
				@click="onRegister"
				value="Inserir Novo Valor"
			/>
			<b-table 
					class="table-v2"
					striped 
					hover 
					bordered
					small
					show-empty
					sort-icon-left
					responsive
					head-variant="light"
					empty-text="Nenhum item encontrado"
					:busy="parent.config.loading.content"
					:items="tableData" 
					:fields="tableHead"
					:stacked="(this.device == 'xs')"
				>	
					<!--FORMATAR CABEÇALHO-->
					<template v-slot:head()="data">
						<span style="font-size:7pt">{{ data.label.toUpperCase() }}</span>
					</template>

					<!--STYLE TABLE-->
					<template v-slot:table-colgroup="scope">
						<col
						v-for="field in scope.fields"
						:key="field.key"
						:style="{ width: field.width }"
						>
					</template>

					<!--FORMATAR COLUNAS-->
					<template v-slot:cell()="data">

						<el-input
							@change="formatData"
							v-if="data.field && data.field.show_text"
							v-model="data.item._data[data.field.key]"
							:maxlength="150"
							:disabled="data.item._data.ativo == 0"
							type="text"
						/>

						<el-input-number
							@change="formatData"
							v-else-if="data.field && data.field.show_numeric"
							v-model="data.item._data[data.field.key]"
							:disabled="data.item._data.ativo == 0"
							:min="0"
						/>

						<el-select
							@change="formatData"
							v-else-if="data.field && data.field.show_select"
							v-model="data.item._data[data.field.key]"
							:clearable="true"
							placeholder="Selecione"
							:disabled="data.item._data.ativo == 0 || (parent.formData.id_tipo_campo != 212 && parent.formData.id_tipo_campo != 217)"
						>
							<el-option
								v-for="tipo in tipo_campos"
								:key="tipo.id"
								:label="tipo.descricao"
								:value="tipo.id"
								:title="tipo.obs"
							>
								<div>{{ tipo.descricao }}</div>
								<div style="color: #8492a6; font-size: 13px" v-if="tipo.obs">{{ tipo.obs }}</div>
							</el-option>
						</el-select>

						<el-switch
							@change="formatData"
							v-else-if="data.field && data.field.show_boolean"
							v-model="data.item._data[data.field.key]"
							:active-value="1"
							:inactive-value="0"
						/>
					</template>

					<template v-slot:cell(buttons)="data">
						<div class="text-centers">
							<ed-button
								icon="fa fa-trash"
								type="danger"
								size="mini"
								title="Deletar Registro"
								@click="onDelete(data)"
							/>
						</div>
					</template>
				</b-table>
		</div>
	</div>
</template>

<script>

	import EdButton from 'common/button'
	import Rest from 'common/rest'

  	export default {
  		name:"empresa",
  		components: {EdButton},
		mixins:[Rest],
		props:{
			parent:{
				type: Object,
                default: null
			}
		},
		watch:{
			'parent.showForm'(){
				this.inicialize();
			},
			'parent.formData.id'(){
				this.inicialize();
			},
			'parent.formData.id_tipo_campo'(){
			}
		},
  		data () {
		   	return {
		   		tableHead:[
					{
						key: 'ordem',
						show_numeric:true,
						sortable: true,
						width:'200px',
						label: 'Ordem',
		            },
		            {
						key: 'nome',
						show_text:true,
						sortable: true,
						label: 'Nome',
					},
					{
						key: 'unidade',
						show_text:true,
						sortable: true,
						label: 'Unidade',
					},
					{
						key: 'id_tipo_campo',
						show_select:true,
						sortable: true,
						label: 'Tipo de Campo',
					},
					// {
					// 	key: 'padrao',
					// 	show_boolean:true,
					// 	sortable: true,
					// 	width:'200px',
					// 	label: 'Definir como Padrão?',
					// },
					{
						key: 'ativo',
						show_boolean:true,
						sortable: true,
						width:'200px',
						label: 'Item Ativo?',
					},
					{
						key: 'buttons',
						label: '',
						width:'50px',
					},
		   		],
				tableData:[],
				tipo_campos:[]
			}
		},

		created(){
		},

		mounted() {
			this.inicialize();
			this.handleParametros();
		},
		methods: {

			inicialize(){

				var tableData = [];

				for (let i = 0; i < this.parent.formData.tabela_valores.length; i++) {
					const element = this.parent.formData.tabela_valores[i];
					
					var item = {
						id:element.id,
						id_tab_ver_col:this.parent.formData.id,
						id_tipo_campo: (element.tipo_campo ? element.tipo_campo.id : null),
						ordem:element.ordem,
						nome:element.nome,
						unidade:element.unidade,
						padrao:element.padrao,
						ativo:element.ativo,
						_data:element
					}

					tableData.push(item);
				}

				this.tableData = tableData;
			},

			onRegister(){
				
				var data = {
					id:0,
					id_tab_ver_col:this.parent.formData.id,
					id_tipo_campo: null,
					unidade:null,
					ordem:(this.parent.formData.tabela_valores.length+1),
					nome:'ITEM '+(this.parent.formData.tabela_valores.length+1),
					ativo:1,
					padrao:0
				};


				this.tableData.push({
					id:0,
					id_tab_ver_col:this.parent.formData.id,
					id_tipo_campo: null,
					ordem:(this.parent.formData.tabela_valores.length+1),
					nome:null,
					unidade:null,
					ativo:1,
					padrao:0,
					_data:data
				});
				this.formatData();
			},

			onDelete(item){
				this.tableData.splice(item.index,1);
				this.formatData();
			},

			formatData(){

				this.parent.formData.tabela_valores = [];

				for (let i = 0; i < this.tableData.length; i++) {
					const element = this.tableData[i];
					this.parent.formData.tabela_valores.push(element._data);
				}
			},

			handleParametros(){

				this.post('tipo/parent',{codigo:[207], exclude: [210,211,212,213,214]}).then((result) =>{

					result = result[0];

					this.tipo_campos = [];

					if(result.status == 200){
						this.tipo_campos = result.data['207'];
					}

				});
			},
		}
  	}
</script>


// WEBPACK FOOTER //
// valores.vue?2f3435f2